import React, { useState, useEffect } from "react";
import WeekViewScheduleEvent from "./WeekViewScheduleEvent";

const hours = [
	"06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20"
]



const DiaryScheduleView = (props) => {
    return (
        <div className="week-view">
            <div className="hour-label-container">
                {
                    hours.map(hour => {
                        return <div key={hour} className="hour-label">
                            { hour }
                        </div>
                    })
                }
            </div>

            <div key="day" className="day">
                {
                    hours.map(hour => {
                        return <div key={hour} className="diary-hour" onClick={() => props.openModalClick(props.selectedSchedule, hour)} />
                    })
                }

                {
                    props.events && props.events.map(e => {
                        return <WeekViewScheduleEvent key={e.id} event={e} openEvent={props.showModal} />
                    })
                }
            </div>
        </div>
    )

}

export default DiaryScheduleView;